import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  backButton: {
    '& svg path': {
      fill: `rgb(${theme.palette.gallery})`,
      transition: `fill ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeOut}`,
    },
    '&:hover, &:focus': {
      '& svg path': {
        fill: `rgb(${theme.palette.white})`,
      },
      outline: 0,
    },
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
  },
  buttonBox: {
    textAlign: 'right',
  },
  header: {
    backgroundColor: `rgb(${theme.palette.black})`,
    boxShadow: `0px 10px 10px rgb(${theme.palette.black})`,
    display: 'flex',
    height: '100%',
    maxHeight: '50px',
    position: 'fixed',
    top: 0,
    transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeOut}`,
    width: '100%',
    willChange: 'max-height',
    zIndex: '100',
    [theme.breakpoints.up('sm')]: {
      padding: '1rem 2rem 0 2rem',
      maxHeight: '75px',
      boxShadow: `0px 15px 15px rgb(${theme.palette.black})`,
    },
  },
  headerWrapper: {
    boxShadow: `0px 15px 15px rgb(${theme.palette.black})`,
  },
  siteLogo: {
    '&:hover, &:focus': {
      opacity: theme.palette.opacity.transparent,
      outline: 0,
    },
    position: 'relative',
    transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeOut}`,
    zIndex: 11,
  },
  siteMenu: {
    alignItems: 'flex-start',
    display: 'flex',
    padding: '1rem 0',
  },
}))

export default useStyles
